

export function archiveDocs(data: string[]) {
  return (dispatch: any, getState: any) => {
    const { auth } = getState();
    dispatch({ type: ARCHIVE_REQUEST });
    return fetch(`/api/documents/archive`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then(async (response) => {
      const data = await response.json();
      if (data.status === "success") {
        dispatch({
          type: ARCHIVE_SUCCESS,
          payload: data.result,
        });
      } else {
        dispatch({ type: ARCHIVE_FAILURE, payload: data });
      }
    });
  };
}


export const ARCHIVE_REQUEST = "Archive.Request";
export const ARCHIVE_SUCCESS = "Archive.Success";
export const ARCHIVE_FAILURE = "Archive.Failure";
export const ARCHIVE_RESET = "Archive.Reset";

export function unarchiveDocs(data: string[]) {
  return (dispatch: any, getState: any) => {
    const { auth } = getState();
    dispatch({ type: UNARCHIVE_REQUEST });

    const options: RequestInit = {
      method: "DELETE",
      headers: {
        "Authorization": `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };

    return fetch(`/api/documents/archive`, options).then(async (response) => {
      const data = await response.json();
      if (data.status === "success") {
        dispatch({ type: UNARCHIVE_SUCCESS, payload: data.result });
      } else {
        dispatch({ type: UNARCHIVE_FAILURE, payload: data });
      }
    });
  };
}

export const UNARCHIVE_REQUEST = "Unarchive.Request";
export const UNARCHIVE_SUCCESS = "Unarchive.Success";
export const UNARCHIVE_FAILURE = "Unarchive.Failure";
export const UNARCHIVE_RESET = "Unarchive.Reset";


